/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_TaskInputs */



/**
* | output |
* | --- |
* | "Tasks (just you)" |
*
* @param {Agenda_Filter_TaskInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_task = /** @type {((inputs?: Agenda_Filter_TaskInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_TaskInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Taken (enkel jij)")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tâches (vous uniquement)")
	return /** @type {LocalizedString} */ ("Tasks (just you)")
});